import React from 'react'

const HamburgerMenu = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40px'
      height='40px'
      viewBox='0 0 24 24'
    >
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M3 6h18M3 12h18M3 18h18'
      />
    </svg>
  )
}

export default HamburgerMenu
